import React, { useState } from "react";
import "../../styles/NewsletterWindow.css";
import closeButton from "../../assets/images/close.png";

const NewsletterWindow = ({ onClose }) => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState(null);

const handleSubscribe = async () => {
    try {
        const response = await fetch("https://connect.mailerlite.com/api/subscribers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${process.env.REACT_APP_MAILERLITE_API_KEY}`,
            },
            body: JSON.stringify({
                email,
                groups: [process.env.REACT_APP_MAILERLITE_GROUP_ID],
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error("Error response:", errorData);
            throw new Error(errorData.message || "Unknown error");
        }

        setStatus("success");
    } catch (error) {
        console.error("Error:", error.message);
        setStatus(`error: ${error.message}`);
    }
};

    return (
        <div className="newsletter-window">
            <div className="newsletter-header">
                <span>Register to my newsletter</span>
                <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer" }}>
                <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
                </button>
            </div>
            <div className="newsletter-content">
                <input
                    type="email"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="email-input"
                />
                <button onClick={handleSubscribe} className="subscribe-button">
                    Subscribe
                </button>
                {status && (
                    <p className={status.startsWith("success") ? "success-message" : "error-message"}>
                        {status === "success"
                            ? "You have been successfully subscribed!"
                            : status.replace("error: ", "")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default NewsletterWindow;